import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Bem from 'bemHelper';
import { I18nHoc } from 'helpers/i18n';
import Link from 'components/link';
import Row, { Col } from 'components/row';

import linksDomik from 'src-sites/domik/links';
import linksBild from 'src-sites/bild/links';
import linksA2 from 'src-sites/a2/links';

import translates from '../about-i18n.json';

const classes = new Bem('blockOurSystem');

@I18nHoc(translates)
export default class OurSystemBlock extends Component {
  static propTypes = {
    className: PropTypes.string,
    topic: PropTypes.string
  };

  links(builder, linkTxt, txt, href, title = linkTxt) {
    const { i18n } = this;
    const linkProps = { builder, href, title, noRedirector: true, external: true, blank: true };

    return (
      <Col {...classes('col')} allPr={0}>
        <Link
          {...classes('link')}
          {...linkProps}
          builderProps={{ title }}
        >
          <span {...classes('linkContent')}>
            <span {...classes('text')} children={linkTxt} />
          </span>
        </Link>
        <div {...classes('description')}>
          <p {...classes('text')} children={txt} />
        </div>
        <Link
          {...classes('link', 'more')}
          {...linkProps}
          builderProps={{ title: i18n('moreDetail') }}
          title={i18n('moreDetail')}
          rel="nofollow"
        >
          <span {...classes('linkContent')}>
            <span {...classes('text')} children={`${i18n('moreDetail')} `} />
            <span {...classes('icon')} children="&rarr;" />
          </span>
        </Link>
      </Col>
    );
  }

  render() {
    const { i18n } = this;
    const { className } = this.props;
    const topic = i18n('aboutOurSystemH2');

    return (
      <div {...classes({ extra: className })}>
        <Row {...classes('row', 'topic')}>
          <Col allPr={0}><div {...classes('text', 'h2')}><h2 children={topic} /></div></Col>
        </Row>
        <Row {...classes('row', 'block')} mpColumn>
          {this.links(
            linksDomik.sectionDomik,
            'Domik.ua',
            i18n('aboutOurSystemDomik')
          )}
          {this.links(
            linksBild.sectionBild,
            'Bild.ua',
            i18n('aboutOurSystemBild')
          )}
          {this.links(
            linksA2.sectionA2,
            i18n('aboutOurSystemА2Topic'),
            i18n('aboutOurSystemА2')
          )}
        </Row>
      </div>
    );
  }
}
